<template>

    <!-- PAGE CONTENT
    ============================================= -->	
    <div id="page" class="page">


       <header_menu></header_menu>

        <!-- PRESENTATION-->	
        <section id="hero-1" class="bg-fixed hero-section division">
            <div class="container">	
                <div class="row">


                    <!-- HERO TEXT -->
                    <div class="col-md-7 col-lg-6">
                        <div class="hero-txt white-color">	


                            <!-- Title -->
                            <h2 class="h2-lg " data-animation="fadeInUp" data-animation-delay="300">
                                Profitez de jusqu'à <span class="precent_rem"> 20%</span> de réduction chez nos partenaires
                            </h2>

                            <!-- Text -->
                            <p class="p-lg " data-animation="fadeInUp" data-animation-delay="400">
                               Nos cartes Visa vous offrent une sécurité maximale et des avantages supplémentaires pour chaque achat que vous effectuez.<br>
                                Ne manquez pas cette opportunité de maximiser vos économies et d'obtenir plus de valeur pour votre argent.
                                Achetez nos cartes Visa dès maintenant!
                            </p>

                            <!-- HERO STORE BADGES -->													
                            <div class="hero-stores-badge " data-animation="fadeInUp" data-animation-delay="500">                                


                                <a href="https://cabine.apaym.com/achat-cartes"><button class="learn-more">
                                <span class="circle" aria-hidden="true">
                                <span class="icon arrow"></span>
                                </span>
                                <span class="button-text">Acheter une carte Visa</span>
                                </button> </a>                                                            
                                                    
                            </div>	<!-- End Store Badges -->
                                
                        </div>	 <!-- End row -->   
                    </div>	 <!-- End container --> 

                    <!-- HERO IMAGE -->
                    <div class="col-md-5 col-lg-5 offset-lg-1 " data-animation="fadeInRight" data-animation-delay="400">	
                        <div class="hero-img">				
                            <img class="img-fluid first_im" src="@/assets/images/privileges.png" alt="hero-image">
                        </div>
                    </div>


                </div>	   <!-- End row --> 
            </div>      <!-- End container --> 
        </section>	
        <!-- END PRESENTATION -->    

        <!-- MULTI CHOICES SERVICES-->
        <section id="features-1" class="p-bottom-60 featuress-section division">
            <div class="container">
                <div class="row">

                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1 partner">	
                        <div class="download-txt">
                            
                            <!-- Title -->
                            <h2 class="h2-xs">Nos partenaires</h2>

                            <!-- Text -->
                            <p class="p-lg">Bénéficiez d'un taux de réduction de 20% <br>sur les produits et services, ainsi que des privilèges exclusifs</p> 
                            
                            <div>     
                            
                            <VueMultiselect  
                                class="mselect" 
                                v-model="value" 
                                placeholder="Rechercher un partenaire" 
                                selectLabel=""
                                deselectLabel=""
                                selectedLabel="selectionné"
                                label="nom" 
                                track-by="id" 
                                :options="privileges" 
                                :multiple="false" 
                                @select="onSelect"
                                >
                            </VueMultiselect>


                            </div>

                        </div>
                    </div>	 <!-- END DOWNLOAD TEXT -->
                </div>	   <!-- End row -->		

                <div class="row">

                    <div class="row mt-30">
                        
                       

                            <div class="col-md-3 col-sm-6 prv" v-for="item in privileges" :key="item.id" >
                                <div class="box16">

                                    <!-- <router-link :to="{ name: 'privileges_details', params: { message: slugify(item.nom)+'-'+item.id } }">Aller à la page 2</router-link> -->
                                   
                                   <img :src=" 'https://carte.abidjan.net/images/img_partenaire/'+ item.img3 " class="pic-1"/>
                                   
                                    <router-link :to=" '/partenaire/'+ slugify(item.nom) +'-'+item.id "> <div class="box-content">
                                        
                                    
                                        <img :src=" 'https://carte.abidjan.net/images/img_partenaire/'+ item.img1 " class="pic-1 title p_icon "/>
                                            <h3 class="title t_card">{{ item.nom }}</h3>
                                        
                                            <ul class="social">
                                                <li class="brands"><a :href="item.facebook" target="_blank"><font-awesome-icon icon="fa-brands fa-facebook-f" /></a></li>
                                                <li class="brands"><a href="#"><font-awesome-icon icon="fa-brands fa-twitter" /></a></li>
                                                <li class="brands"><a href="#"><font-awesome-icon icon="fa-brands fa-instagram" /></a></li>                            
                                            </ul>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                                            
                    </div>                  


                </div>	   
                <!-- End row -->		

                
            </div>	   <!-- End container -->		
        </section>	
        <!-- END MULTI CHOICES SERVICES -->        
       
        <footer_menu></footer_menu>    

        <!-- <RouterView/> -->

    </div>

</template>

<script>
    import header_menu  from '../components/header_menu.vue';
    import footer_menu  from '../components/footer_menu.vue';
    import axios  from 'axios';
    import VueMultiselect from 'vue-multiselect'

    export default{
        name:'home_view',
        components:{
        VueMultiselect,
        'header_menu' :header_menu,
        'footer_menu' :footer_menu,
        }, 
        
                       
               
        methods: {   

            getLocalities(){
                axios.get('https://carte.abidjan.net/assets-apaym/liste_localites.php').then(res => {
                    //console.log('>>>>>>>>>Success')
                    this.localities = res.data
                    //console.log(this.localities)
                }).catch(error=>{
                    console.log('Error')
                    console.log(error.response)
                })
            },

            onSelect(selectedOption) {
            //window.localStorage.setItem("id_point_de_vente", selectedOption.id);
            this.$router.push("/partenaire/"+ this.slugify(selectedOption.nom +'-'+ selectedOption.id));
            },


            // Slugity a string

            slugify(str)
            {
                str = str.replace(/^\s+|\s+$/g, '');

                // Make the string lowercase
                str = str.toLowerCase();

                // Remove accents, swap ñ for n, etc
                var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
                var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
                for (var i=0, l=from.length ; i<l ; i++) {
                    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
                }

                // Remove invalid chars
                str = str.replace(/[^a-z0-9 -]/g, '')
                    // Collapse whitespace and replace by -
                    .replace(/\s+/g, '-')
                    // Collapse dashes
                    .replace(/-+/g, '-');

                return str;
            }, 

        

            

        },

        data(){
            return{                
                privileges: [],
                value: [],
                //localities: [],
            }

        },   
        mounted(){
          axios.get('https://carte.abidjan.net/assets-apaym/liste_privileges.php')
          .then((reponse) => {
          
          this.privileges = [...reponse.data];
          //console.log(this.privileges)
          });
        },  
        
        created() {
    this.getLocalities()
  },
           
    } 

</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.mselect{
    max-width: 440px;
    margin: auto;
    margin-top: 40px;
}
.prv{
    margin-bottom: 25px;

}
.brands{
   text-align: center;
}
.p_icon{
width: 60px !important;
height: 60px !important;
border-radius: 50%;
border: 2px solid #261b64;
  
}
.t_card{
    text-shadow: 2px 2px #261b64;
    color:#fff   
}
.partner{
    text-align: center;
    padding-top: 30px;
    margin-bottom: 50px;
}
h2.h2-lg { font-size: 2.8rem; }   /* 60px */

.first_im{
    max-width: 560px;
}


@media screen and (max-width: 767px) {

    .mt-30{
        padding: 20px !important;
    }
    .first_im {
    max-width: 330px !important;
}

}
/*fin media query 768px */



#hero-1 .hero-txt {
    margin-top: 50px;
}

button {
 position: relative;
 display: inline-block;
 cursor: pointer;
 outline: none;
 border: 0;
 vertical-align: middle;
 text-decoration: none;
 background: transparent;
 padding: 0;
 font-size: inherit;
 font-family: inherit;
}

button.learn-more {
 width: 17rem;
 height: auto;
}

button.learn-more .circle {
 transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
 position: relative;
 display: block;
 margin: 0;
 width: 3rem;
 height: 3rem;
 background: #281d67;
 border-radius: 1.625rem;
}

button.learn-more .circle .icon {
 transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
 position: absolute;
 top: 0;
 bottom: 0;
 margin: auto;
 background: #fff;
}

button.learn-more .circle .icon.arrow {
 transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
 left: 0.625rem;
 width: 1.125rem;
 height: 0.125rem;
 background: none;
}

button.learn-more .circle .icon.arrow::before {
 position: absolute;
 content: "";
 top: -0.29rem;
 right: 0.0625rem;
 width: 0.625rem;
 height: 0.625rem;
 border-top: 0.125rem solid #fff;
 border-right: 0.125rem solid #fff;
 transform: rotate(45deg);
}

button.learn-more .button-text {
 transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 padding: 0.75rem 0;
 margin: 0 0 0 1.85rem;
 color: #fff;
 font-weight: 600;
 line-height: 1.6;
 text-align: center;
 text-transform: uppercase;
 font-style: normal !important;
}

button:hover .circle {
 width: 100%;
}

button:hover .circle .icon.arrow {
 background: #fff;
 transform: translate(1rem, 0);
}

button:hover .button-text {
 color: #fff;
}
.precent_rem{
    color: #ff9e00;
    font-size: 4rem;
}


/* cards privileges */
.box16{text-align:left;color:#fff;position:relative}
.box16 .box-content,.box16:after{width:100%;position:absolute;left:0}
.box16:after{content:"";height:100%;background:linear-gradient(to bottom,rgba(0,0,0,0) 0,rgba(0,0,0,.08) 69%,rgba(0,0,0,.76) 100%);top:0;transition:all .5s ease 0s}
.box16 .post,.box16 .title{transform:translateY(145px);transition:all .4s cubic-bezier(.13,.62,.81,.91) 0s}
.box16:hover:after{background:linear-gradient(to bottom,rgba(0,0,0,.01) 0,rgba(0,0,0,.09) 11%,rgba(0,0,0,.12) 13%,rgba(0,0,0,.19) 20%,rgba(0,0,0,.29) 28%,rgba(0,0,0,.29) 29%,rgba(0,0,0,.42) 38%,rgba(0,0,0,.46) 43%,rgba(0,0,0,.53) 47%,rgba(0,0,0,.75) 69%,rgba(0,0,0,.87) 84%,rgba(0,0,0,.98) 99%,rgba(0,0,0,.94) 100%);}
.box16 img{width:100%;height:auto}
.box16 .box-content{padding:20px;margin-bottom:30px;bottom:0;z-index:1}
.box16 .title{font-size:22px;font-weight:700;margin:0 0 10px}
.box16 .post{display:block;padding:8px 0;font-size:15px}
.box16 .social li a,.box17 .icon li a{border-radius:50%;font-size:20px;color:#fff}
.box16:hover .post,.box16:hover .title{transform:translateY(0)}
.box16 .social{list-style:none;padding:0 0 5px;margin:40px 0 25px;opacity:0;position:relative;transform:perspective(500px) rotateX(-90deg) rotateY(0) rotateZ(0);transition:all .6s cubic-bezier(0,0,.58,1) 0s}
.box16:hover .social{opacity:1;transform:perspective(500px) rotateX(0) rotateY(0) rotateZ(0)}
.box16 .social:before{content:"";width:50px;height:0px;background:#fff;margin:0 auto;position:absolute;top:-23px;left:0;right:0; }
.box16 .social li{display:inline-block}
.box16 .social li a{display:block;width:40px;height:40px;line-height:40px;background:#261b64;margin-right:10px;transition:all .3s ease 0s}
.box17 .icon li,.box17 .icon li a{display:inline-block}
.box16 .social li a:hover{background:#ff9e00}
.box16 .social li:last-child a{margin-right:0}
@media only screen and (max-width:990px){.box16{margin-bottom:30px}
}
/* fin card privileges */
</style>